import { render } from "./UserTabs.vue?vue&type=template&id=681327f9"
import script from "./UserTabs.vue?vue&type=script&lang=js"
export * from "./UserTabs.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__